<template>
    <div>
        <div>
            <h1 class="catalogTitle">
                {{ category.title }}
                <template v-if="isSearchPage">
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    {{ i18n('for') }} '<span v-html="queryString"></span>'
                </template>
            </h1>
            <LazyHydrate never>
                <div class="catalogMainText" v-html="mainText" />
            </LazyHydrate>
            <picture v-if="category.banner" class="category-banner">
                <source
                    media="(min-width: 992px)"
                    :srcset="`${category.banner['1140']}, ${category.banner['2280']} 2x`"
                />
                <source
                    media="(min-width: 481px)"
                    :srcset="`${category.banner['720']}`"
                />
                <img
                    class="mb-20"
                    :src="category.banner['480']"
                    fetchpriority="high"
                    alt=""
                />
            </picture>
            <!-- eslint-disable vue/no-v-html -->

            <LazyHydrate never>
                <div
                    v-if="category.isContentMode || category.isMixedMode"
                    v-html="cmsBlock"
                />
            </LazyHydrate>
        </div>
    </div>
</template>
<script>
import { unescape } from 'lodash'
import { mapGetters } from 'vuex'
import LazyHydrate from 'vue-lazy-hydration'
import resizeObserver from '@vue/utils/resizeObserver.js'

export default {
    components: {
        LazyHydrate
    },
    mixins: [resizeObserver],
    props: {
        category: {
            type: Object,
            required: true
        },
        queryString: {
            type: String,
            default: ''
        },
        isSearchPage: {
            type: Boolean,
            default: false
        },
        params: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            cmsBlockData: null
        }
    },
    computed: {
        ...mapGetters(['i18n']),
        cmsBlock() {
            return unescape(this.category.cmsBlock) || null
        },
        categoryDescription() {
            return unescape(this.category.categoryDescription) || null
        },
        mainText() {
            return unescape(this.category.mainText) || null
        }
    },

    mounted() {
        this.moveBreadcrumbs()
    },
    methods: {
        moveBreadcrumbs() {
            const breadcrumbs = document.querySelector('.breadcrumbs__wrapper')
            const container = document.querySelector(
                '.breadcrumbs-desktop-container'
            )
            container.appendChild(breadcrumbs)
        }
    }
}
</script>
<style lang="scss">
.catalogTitle {
    font-weight: 500;

    @media #{$media-xs} {
        font-size: 20px;
    }
}

.catalogMainText {
    font-size: 16px;

    @media #{$media-xs} {
        font-size: 12px;
    }
}

picture.category-banner {
    &,
    & img {
        width: 100%;
    }
}
</style>
